import axios from './config';
import { API_V1_1, API_V1, FETCHING_VALIDATION_MERCHANT, GET_VALIDATION_MERCHANT, ERROR_FETCHING_VALIDATION_MERCHANT, SECRET_KEY } from './constants';
import AES256 from 'aes-everywhere';


export const data_validation = (data) => {
    return (dispatch, getState) => {
        dispatch(fetcing())

        return new Promise((resolve, reject) => {
        axios.post(API_V1_1 + `/merchants/validation`, data)
          .then(({data}) => {
            dispatch({ type: GET_VALIDATION_MERCHANT, data: data.data});
            resolve(data)
          }).catch(error => {
            dispatch(errorFetcing(error))
            reject(error)
          })
        });
    }
}

export const confirm_pin = (pin) => {
  return (dispatch, getState) => {
      // dispatch(fetcing())
      return new Promise((resolve, reject) => {
      axios.post(API_V1_1 + `/auth/pin-validation`, pin)
          .then(({data}) => {
            resolve(data)
          }).catch(error => {
            // dispatch(errorFetcing(error))
            reject(error)
          })
      });
  }
}

export const confirm_otp = (data) => {
  return (dispatch, getState) => {

      return new Promise((resolve, reject) => {
      axios.post(API_V1 + `/otp/validate`, data)
          .then(({data}) => {
            resolve(data)
          }).catch(error => {
            dispatch(errorFetcing(error))
            reject(error)
          })
      });
  }
}

export const post_data = (data) => {
  return (dispatch, getState) => {
      dispatch(fetcing())

      return new Promise((resolve, reject) => {
      axios.post(API_V1_1 + `/self-register/validate`, data)
          .then(({data}) => {
            resolve(data)
          }).catch(error => {
            dispatch(errorFetcing(error))
            reject(error)
          })
      });
  }
}

export const resend_otp = (data) => {
  return (dispatch, getState) => {
      // dispatch(fetcing())

      return new Promise((resolve, reject) => {
      axios.post(API_V1_1 + `/self-register/otp/resend`, data)
          .then(({data}) => {
            resolve(data)
          }).catch(error => {
            dispatch(errorFetcing(error))
            reject(error)
          })
      })
  }
}

// export const send_logs = (params) => {
//   return (dispatch, getState) => {

//       return new Promise((resolve, reject) => {
//       axios.post(API_V1 + `/self-register/log`, params)
//           .then(({data}) => {
//             resolve(data)
//           }).catch(error => {
//             dispatch(errorFetcing(error))
//             reject(error)
//           })
//       })
//   }
// }

export function encryptPIN(pin) {
  return () => {
    // Encrypt
    return AES256.encrypt(pin, SECRET_KEY)
  }
}

export function decryptPIN(encryptPIN) {
  return () => {
    // Decrypt
    return AES256.decrypt(encryptPIN, SECRET_KEY)
  }
}

export function goCloseNative(data) {
  return () => {
    if (isAndroid()) {
      window.webPageClosed()
    } else {
      return console.log("goCloseNative False")
    }
    localStorage.clear();
  }
}

export function goBackPressed(data) {
  return () => {
    if (isAndroid()) {
      window.webPageBackPressed()
    } else {
      return console.log("goBackPressed False")
    }
  }
}

export function goBackSuccess(data) {
  return () => {
    if (isAndroid()) {
      var obj = JSON.stringify(data)

      // SEND LOGS
      const params = {
        title: 'SEND_REQ_TO_NATIVE =>',
        message: `${obj}`
      }
      window.sendLogs(params)
      
      // Hit method native
      window.registerSuccess(obj)
      
    } else {
      return console.log("goBackSuccess False")
    }
    localStorage.clear();
  }
}

export function disableCapture() {
  return () => {
    const dataNative = JSON.parse(localStorage.getItem('DATA_NATIVE'));
    if (isAndroid() && dataNative.version_id >= 105) {
      window.webPageDisableCapture()
    }
  }
}

export function enableCapture() {
  return () => {
    const dataNative = JSON.parse(localStorage.getItem('DATA_NATIVE'));
    if (isAndroid() && dataNative.version_id >= 105) {
      window.webPageEnableCapture()
    }
  }
}

let isAndroid = () => {
  return /Android/.test(window.navigator.userAgent)
}

const fetcing = (offers) => {
  return { type: FETCHING_VALIDATION_MERCHANT, offers}
}

const errorFetcing = (error) => {
  return { type: ERROR_FETCHING_VALIDATION_MERCHANT, error  }
}
